import styled from "styled-components";

export const StyledButton = styled.button`
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.button};
  color: ${({ theme }) => theme.colors.buttonFont};
  height: 44px;
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:disabled {
    background-color: #00000070;
    color: #ffffff;
    cursor: not-allowed !important;
    pointer-events: none !important;
    opacity: 0.9;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-width: max-content;
  }
`;

export const Spinner = styled.div`
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-top: 2px solid #000;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 0.6s linear infinite;
  display: inline-block;
  margin-right: 8px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
